
export const API_URL = "https://mevent-phone-4f690ce5228b.herokuapp.com/api/";
export const SESSION_COOKIE = "userPhoneMeventSupplierMobileCutterYLive";

/*
export const API_URL          = "http://localhost:40123/api/";
export const SESSION_COOKIE   = "userMeventSupplierMobileCutterYLocal";
*/
export const SMALL_PROCESSING = "http://cjmarketing.co/image_directory/orange_circles.gif";
export const WP_URL           = "https://new.cjmarketing.co/wp-json/wp/v2/";